var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHideMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "12e_admin_users_edit_inactive",
    transform: "translate(-235.000000, -100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(235.000000, 100.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#37652C",
    cx: 15,
    cy: 15,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    id: "right-arrow",
    transform: "translate(11.500000, 9.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.80993999,5.5317599 L1.50758316,0.191705758 C1.38494612,0.0680970073 1.22123632,0 1.04667712,0 C0.872117919,0 0.708408124,0.0680970073 0.585771083,0.191705758 L0.195289317,0.584873294 C-0.0587999086,0.841066333 -0.0587999086,1.25745319 0.195289317,1.51325599 L4.64780826,5.99751222 L0.190348963,10.486744 C0.0677119211,10.6103528 0,10.7751319 0,10.9508378 C0,11.1267388 0.0677119211,11.291518 0.190348963,11.4152243 L0.580830728,11.8082942 C0.703564639,11.931903 0.867177564,12 1.04173677,12 C1.21629597,12 1.38000576,11.931903 1.5026428,11.8082942 L6.80993999,6.46336209 C6.93286764,6.33936309 7.00038582,6.17380347 7,5.9978049 C7.00038582,5.82112341 6.93286764,5.65566134 6.80993999,5.5317599 Z",
    id: "Path",
    transform: "translate(3.500000, 6.000000) scale(-1, 1) translate(-3.500000, -6.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideMenu);
export default __webpack_public_path__ + "static/media/hide-menu.a7600b39176b0dba39793fc2f3499bf4.svg";
export { ForwardRef as ReactComponent };